export const REVIEW_MAP_FIXTURE = Object.freeze({
  mindmapId: 'local-review-map',
  nodes: [
    {
      id: 'review-root',
      text: 'Project launch',
      position: { x: 520, y: 320 },
      layoutSize: { width: 260, height: 110 },
      layout: { side: 'right', order: 0, pinned: true },
      color: 'linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)',
      isRoot: true,
    },
    {
      id: 'review-research',
      text: 'Research customers',
      position: { x: 120, y: 220 },
      layoutSize: { width: 260, height: 110 },
      layout: { side: 'left', order: 0, pinned: false },
      color: 'linear-gradient(135deg, #0891b2 0%, #0f766e 100%)',
    },
    {
      id: 'review-release',
      text: 'Prepare release',
      position: { x: 920, y: 420 },
      layoutSize: { width: 260, height: 110 },
      layout: { side: 'right', order: 0, pinned: false },
      color: 'linear-gradient(135deg, #ea580c 0%, #dc2626 100%)',
    },
  ],
  relationships: [
    { parentId: 'review-root', childId: 'review-research' },
    { parentId: 'review-root', childId: 'review-release' },
  ],
  root: 'review-root',
  selectedId: 'review-root',
});

const OVERLAPPING_ROUTING_GEOMETRY = [
  [126.72, 136.82, 260, 110], [-541.19, -87.61, 260, 110],
  [-599.77, 71.92, 260, 110], [-598.83, 251.36, 260, 110],
  [-580.30, -30.93, 260, 110], [-142.97, 211.27, 260, 110],
  [315.16, 394.26, 260, 110], [377.45, 482.84, 260, 110],
  [326.99, 644.46, 260, 110], [575.27, 581.94, 260, 110],
  [177.08, 533.89, 260, 110], [-462.70, -348.98, 96, 44],
  [-326.31, -413.15, 96, 44], [-49.38, 146.32, 96, 44],
  [19.78, -7.91, 96, 44], [-500.98, -249.49, 96, 44],
  [-129.79, 72.92, 96, 44], [542, 303, 260, 110],
  [712, 265, 260, 110], [712, 342, 260, 110],
  [300, 300, 260, 110], [-49.38, -134.58, 96, 44],
  [89.29, 330.53, 96, 44], [712, 419, 260, 110],
  [882, 523, 260, 110],
];

const OVERLAPPING_ROUTING_EDGES = [
  [14, 3], [14, 2], [14, 4], [14, 11], [14, 15], [14, 1], [14, 12],
  [20, 14], [0, 21], [0, 5], [0, 16], [20, 17], [20, 0], [7, 9],
  [17, 23], [23, 24], [0, 22], [6, 10], [0, 13], [17, 19], [17, 18],
  [7, 8], [6, 7], [20, 6],
];

export const OVERLAPPING_ROUTING_REVIEW_MAP_FIXTURE = Object.freeze({
  mindmapId: 'local-overlapping-routing-review-map',
  nodes: OVERLAPPING_ROUTING_GEOMETRY.map(([x, y, width, height], index) => ({
    id: `routing-node-${index}`,
    text: `Routing node ${index}`,
    position: { x, y },
    layoutSize: { width, height },
    layout: { side: x < 300 ? 'left' : 'right', order: index, pinned: index === 20 },
    color: 'linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)',
    isRoot: index === 20,
  })),
  relationships: OVERLAPPING_ROUTING_EDGES.map(([parentIndex, childIndex]) => ({
    parentId: `routing-node-${parentIndex}`,
    childId: `routing-node-${childIndex}`,
  })),
  root: 'routing-node-20',
  selectedId: 'routing-node-20',
});

export function getReviewMapFixture(search = '') {
  const fixture = new URLSearchParams(search).get('fixture');
  return fixture === 'overlapping-routing'
    ? OVERLAPPING_ROUTING_REVIEW_MAP_FIXTURE
    : REVIEW_MAP_FIXTURE;
}
